<template>
  <div class="c-tabs">
    <div
      class="c-tabs__tabs o-grid o-grid--direction-row o-grid--align-items-center o-grid--justify-content-center"
    >
      <div class="o-grid__group">
        <div
          class="o-grid__item c-tabs__tab"
          v-for="(tab, name) in tabs"
          tabindex="0"
          :key="name.id"
          :class="{ 'c-tabs__tab--active': selected === name }"
          @keyup.enter="selected = name"
          @click="selected = name"
        >
          <svg
            class="c-tabs__tab-icon o-svg-icon"
            viewBox="0 0 64 64"
            type="image/svg+xml"
          >
            <use
              :xlink:href="`spritemap.svg#sprite-` + `${tab.icon}`"
              x="0"
              y="0"
            ></use>
          </svg>
          <div class="c-tabs__tab-name">
            {{ tab.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="c-tabs__content">
      <transition name="o-transition__fade" mode="out-in">
        <component :is="`CallCenterADMIN` + `${selected}`"></component>
      </transition>
    </div>
  </div>
</template>

<script>
import CallCenterADMINmanufacturers from "@/components/Admin/TAB/manufacturers.vue";
export default {
  name: "c-tabs",
  data() {
    return {
      tabs: {
        manufacturers: {
          name: "Producenter & modeller",
          icon: "heartstarter"
        }
      },
      selected: "manufacturers"
    };
  },
  components: {
    CallCenterADMINmanufacturers
  }
};
</script>

<style lang="scss">
.c-tabs {
  $root: &;
  margin: 0 0 2px;
  &__tabs {
    background-color: $s-cp-neutral-white;
  }
  &__tab {
    width: 110px;
    height: 85px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
    cursor: pointer;

    &--active {
      background-color: $s-cp-neutral-900;
      border-right: 1px solid $s-cp-neutral-600;
      border-left: 1px solid $s-cp-neutral-600;

      #{$root}__tab-icon {
        fill: $s-cp-sup-red;
      }
    }
  }
  &__tab-name {
    margin: 0 auto;
    @include setStyles("12", $s-typography-sizes);
    text-align: center;
  }
  &__tab-icon {
    fill: $s-cp-neutral-300;
    width: 40px;
    height: 40px;
    margin: 0 auto;
    display: block;
  }
  &__buttons {
    flex: 0 0 auto;
    margin: 0 25px 0 auto;
    display: flex;
    flex-direction: row;
  }

  &__button {
    & + & {
      margin-left: 15px;
    }
  }

  &__content {
    padding: toRem(50px 40px);
    background-color: $s-cp-neutral-900;
    border-top: 1px solid $s-cp-neutral-600;
    margin: -1px 0 1px;
  }
}
</style>
